import { Component, Input, OnChanges, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';

// client (demo services)
// import { HttpClient } from "../services/client"
import { DemoService } from '../../../demo.service';


// interface (models)
// import { IUser } from "../services/interfaces"

import { FilterService, GridComponent, PageService, PdfExportService, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager } from '@syncfusion/ej2-data';
import { FilterSettingsModel } from '@syncfusion/ej2-grids';

import { IFilter } from '@syncfusion/ej2-angular-grids';
import {
  ToolbarItems, GroupSettingsModel,
  RowDataBoundEventArgs
} from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { IFilterUI } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { HotToastService } from '@ngneat/hot-toast';


import { SubjectNotes } from './../../../shared/models/subjectNotes.model';
import { inputs } from '@syncfusion/ej2-angular-dropdowns/src/drop-down-list/dropdownlist.component';
@Component({
  selector: 'app-users-grid',
  templateUrl: './users-grid.component.html',
  styleUrls: ['./users-grid.component.css']
})
export class UsersGridComponent implements OnInit, OnChanges {



  // passed Values.
  // setup as observable?
  @Input() item_id: Observable<any[]>; // impliments on changes. // Base set to Job_ID
  @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data?= false; // if data.model is sent use this instead of item_id

  @Input() item_user_level_id = null; // default to agent just in case
  @Input() item_brand_type_id = null;
  @Input() item_brand_id = null;
  @Input() item_subject_id?= null;
  @Input() item_subject_number?= null;

  @Input() show_buttons?= false; // yes | no
  @Input() item_title?= '';
  @Input() widget_size?= null; // side | abstract | full

  @Input() job_id?= null;
  @Input() file_number = null; // subject file number
  @Input() reference_number = null; // subject file number


  @ViewChild('grid')
  public grid: GridComponent;

  public pageSettings: Object;
  public pageOptions = { pageSize: 100 };
  public filterOptions: FilterSettingsModel;
  public formatOptions: any;
  // public filterOptions: FilterSettingsModel;
  public filter: IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  initialPage: { pageSize: number; };
  dateFormat: string;


  subject_id: number;
  model: {}; // put model for variables for sql where statements.
  subjectNote: SubjectNotes;
  notes: any;
  brand_id: any;
  users: Object;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  sessionUserLevel: any;
  currentUserVAR: any;
  sessionUserFullName: string;
  sessionUserFirstName: any;

  constructor(
    private _demoService: DemoService,
    private route: ActivatedRoute, private router: Router,
    public datepipe: DatePipe, public gfunc: GlobalFunctionsService,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
  ) {


// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
    this.sessionUserLevel = this.gfunc.currentUserVAR.access_level;
    this.sessionUserFullName = this.gfunc.currentUserVAR.first_name + ' ' + this.gfunc.currentUserVAR.surname;
    this.sessionUserFirstName = this.gfunc.currentUserVAR.first_name;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


    // Setup Grid
    /*         this.toolbarOptions = [ 'Search', {
              text: '-',
              tooltipText: 'Submit Data to Send Agent Notifications', prefixIcon: 'e-test', id: 'Clic2k'
            }
            ]; */
    this.toolbarOptions = ['Search'];
    // this.toolbar = [
    // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];
    //  this.initialPage = { pageSize: 100 };
    this.filterOptions = {
      type: 'Menu'
    };
  //  this.groupOptions = { columns: ['brand_id'] }; // sets auto grouping for the grid
    this.groupOptions = { }; // sets auto grouping for the grid
    this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
    this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.filter = { params: { format: this.dateFormat } };

  }


  // check for changes. to load data.
  ngOnChanges(changes) {
    if (changes.item_id) {
      // deal with asynchronous Observable result
      this.brand_id = changes.item_id.currentValue;
      // this.getJob(this.job_id);
      // this.getFiles();

      // console.log('so it does instigate here on changes');

      // put model.
      this.model = {
        // subject_id: this.subject_id,
        // brand_id: this.item_brand_id, 
        // brand_type_id: this.item_brand_type_id, // show files only related to login brand. client | owner | agent
        // subject_number: this.item_subject_number,
        // file_number: this.file_number,
        // reference_number: this.reference_number,
        // job_id: this.job_id,
        brand_id: this.brand_id,
      };
    ///  this.getSubjectNotesGrid(this.model); // Put Event instead of Get?? Do I get a response of data?// use for all jobs
    
    // create a new put model.
    this.getUserGridData(this.model);
      // this.getSubjectNotesProgressionTable(this.job_id, this.file_number);
    }
  }


  ngOnInit() {
  }


  getUserGridData(model) {
    this._demoService.getUserGridData(model).subscribe(
      data => { this.users = data;
       let res = data[0];
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getUsers() {
    this._demoService.getUsersTableData().subscribe(
      data => { this.users = data;
       let res = data[0];
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


// Grid options
toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}

refreshGrid(){ // refresh the databutton
  this.getUserGridData(this.model);
  this.grid.refresh();
};



}
